import React from 'react';
import { useState } from 'react';
import { ArrowPathIcon, CreditCardIcon, PlusIcon } from '@heroicons/react/24/outline';
import { Button } from 'components/ui';
import { hasPermission } from 'utils/permissionsUtils';

export const PaymentHeader = ({
  transactionCount,
  syncing,
  loading,
  isMobile,
  paidLinkExists,
  canCreatePaymentLink = true,
  paymentLinkBlockedReason = null,
  onRefresh,
  onCreatePaymentLink,
  isStudent = false,
  feeSummary = {},
  isReadOnly = false,
}) => {


  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between pt-1">
      {/* Summary Section */}
      <div className="flex flex-row flex-wrap gap-2 items-center">
        <div className="inline-flex items-center gap-1.5 rounded-md bg-gray-50 border border-gray-200 px-2 py-1 dark:bg-gray-800 dark:border-gray-700 shadow-sm">
          <span className="text-[10px] font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">Total</span>
          <span className="text-[11px] font-bold text-gray-900 dark:text-white">₹{(feeSummary?.totalFees || 0).toLocaleString('en-IN')}</span>
        </div>

        <div className="inline-flex items-center gap-1.5 rounded-md bg-emerald-50 border border-emerald-200 px-2 py-1 dark:bg-emerald-900/20 dark:border-emerald-800/30 shadow-sm">
          <span className="text-[10px] font-medium text-emerald-600 dark:text-emerald-500 uppercase tracking-wider">Paid</span>
          <span className="text-[11px] font-bold text-emerald-700 dark:text-emerald-400">₹{(feeSummary?.recievedFees || 0).toLocaleString('en-IN')}</span>
        </div>

        {feeSummary?.refundedFees > 0 && (
          <div className="inline-flex items-center gap-1.5 rounded-md bg-red-50 border border-red-200 px-2 py-1 dark:bg-red-900/20 dark:border-red-800/30 shadow-sm">
            <span className="text-[10px] font-medium text-red-600 dark:text-red-500 uppercase tracking-wider">Refunded</span>
            <span className="text-[11px] font-bold text-red-700 dark:text-red-400">₹{(feeSummary?.refundedFees || 0).toLocaleString('en-IN')}</span>
          </div>
        )}

        <div className="inline-flex items-center gap-1.5 rounded-md bg-amber-50 border border-amber-200 px-2 py-1 dark:bg-amber-900/20 dark:border-amber-800/30 shadow-sm">
          <span className="text-[10px] font-medium text-amber-600 dark:text-amber-500 uppercase tracking-wider">Pending</span>
          <span className="text-[11px] font-bold text-amber-700 dark:text-amber-400">₹{(feeSummary?.pendingFees || 0).toLocaleString('en-IN')}</span>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-end sm:justify-start shrink-0 w-full sm:w-auto">
        {hasPermission("MLLE") && !paidLinkExists && !isReadOnly && (
          <Button
            variant="filled"
            color={canCreatePaymentLink && (feeSummary?.totalFees === 0 || (feeSummary?.pendingFees || 0) > 0) ? "primary" : "neutral"}
            size="sm"
            onClick={onCreatePaymentLink}
            disabled={!canCreatePaymentLink || ((feeSummary?.totalFees || 0) > 0 && (feeSummary?.pendingFees || 0) <= 0)}
            title={((feeSummary?.totalFees || 0) > 0 && (feeSummary?.pendingFees || 0) <= 0) ? 'Total fee is already covered' : !canCreatePaymentLink ? paymentLinkBlockedReason : 'Create a new payment link'}
            className={`
              transition-all duration-200 text-[11px] whitespace-nowrap h-8
              ${canCreatePaymentLink && (feeSummary?.totalFees === 0 || (feeSummary?.pendingFees || 0) > 0) ? 'hover:shadow-sm' : 'cursor-not-allowed opacity-60'}
              ${isMobile ? 'px-3' : 'px-4'}
            `}
          >
            <PlusIcon className="h-3.5 w-3.5 mr-1.5" />
            {isMobile ? (
              <span>Payment</span>
            ) : (
              <span>Add Payment</span>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};
